'use strict';

angular.module('lmsApp')
    .factory('MetaInfo', function ($resource) {
        return $resource('api/revision', {}, {
            'getRevision': { method: 'GET' }
        });
    });